var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { HttpClient, HttpParams } from '@angular/common/http';
import { CacheService } from '../services/cache.service';
import { map } from 'rxjs/operators';
import { ApiConfigService } from './api-config/api-config.service';
var PointsOfInterestService = /** @class */ (function () {
    function PointsOfInterestService(appConfig, http, cache, apiConfigService) {
        this.appConfig = appConfig;
        this.http = http;
        this.cache = cache;
        this.apiConfigService = apiConfigService;
        this.defaultIcon = 'star_rate';
        this.qualitiesIcons = new Map([
            ['quiet', 'volume_off'],
            ['car friendly', 'directions_car'],
            ['pedestrian friendly', 'directions_walk'],
            ['cafes', 'local_cafe'],
            ['shopping', 'local_mall'],
            ['groceries', 'local_grocery_store'],
            ['nightlife', 'local_bar'],
            ['restaurants', 'restaurant'],
            ['high schools', 'school'],
            ['daycares', 'child_care'],
            ['transit friendly', 'directions_subway'],
            ['parks', 'nature'],
            ['greenery', 'park'],
            ['elementary schools', 'face'],
            ['vibrant', 'celebration'],
            ['cycling friendly', 'pedal_bike']
        ]);
    }
    // Get the mapped icon for a category, falling back to default if no map exists
    PointsOfInterestService.prototype.getScoreIcon = function (category) {
        if (this.qualitiesIcons.has(category.toLowerCase()))
            return this.qualitiesIcons.get(category.toLowerCase());
        return this.defaultIcon;
    };
    PointsOfInterestService.prototype.getBaseUrl = function (route) {
        return this.apiConfigService.getServerRoot(route);
    };
    PointsOfInterestService.prototype.sanitizeAnchors = function (html) {
        if (html) {
            return html.replace(/<a /g, '<a rel="noopener" ');
        }
    };
    /**
     * Used to get the score and POI data from local logic
     *
     * @param lat latitude for a location
     * @param lng longitude for a location
     *
     * @returns an object containing ordered scores and points of interest
     */
    PointsOfInterestService.prototype.getLocationDetails = function (lat, lng) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var base, route, params, hashKey, hashValue;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        base = this.getBaseUrl(this.appConfig.urls.poi.base);
                        route = this.appConfig.urls.poi.base;
                        params = new HttpParams()
                            .set('lat', lat.toString())
                            .set('lng', lng.toString());
                        hashKey = this.cache.getRequestHash(route, params);
                        hashValue = this.cache.get(hashKey);
                        if (hashValue) {
                            return [2 /*return*/, new Promise(function (resolve) {
                                    resolve(hashValue);
                                })];
                        }
                        return [4 /*yield*/, this.http.get(base + route, { params: params, withCredentials: false })
                                .pipe(map(function (res) {
                                // Add the category icons to the object
                                var locationDetails = res.result;
                                locationDetails.scores.forEach(function (scores) { return scores.icon = _this.getScoreIcon(scores.name); });
                                locationDetails.attributionHtml = _this.sanitizeAnchors(locationDetails.attributionHtml);
                                _this.cache.set(hashKey, locationDetails, 300);
                                return locationDetails;
                            }))
                                .toPromise()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return PointsOfInterestService;
}());
export { PointsOfInterestService };
